import styled, { keyframes } from "styled-components"

const scaleIn = keyframes`
  from {
    transform: scale(.85);
  }
  to {
    transform: scale(1);
  }
`
const scaleOut = keyframes`
  from {
    transform: scale(1);
  }
  95% {
    transform: scale(.65);
  }
	to {
	 opacity: 0;
    transform: scale(0);

 }
`

export const BaseToast = styled.div`
  display: flex;
  align-items: flex-start;

  width: 400px;
  padding: var(--size-4);

  box-shadow: var(--elevation-1);
  animation: ${scaleIn} var(--duration-200) ease-in-out;

  &:not(.visible) {
    animation: ${scaleOut} var(--duration-200) ease-in-out;
    animation-fill-mode: forwards;
  }

  &.color--success {
    --toast-color-main: var(--color-success);
  }
  &.color--info {
    --toast-color-main: var(--color-primary);
  }
  &.color--error {
    --toast-color-main: var(--color-error);
  }
  &.color--warning {
    --toast-color-main: var(--color-warning);
  }

  &:not(.bold) {
    --toast-color-title: var(--color-neutral-400);
    --toast-color-body: var(--color-neutral-300);
    --toast-color-icon-start: var(--toast-color-main);
    --toast-color-icon-end: var(--color-neutral-200);
    --toast-color-background: var(--color-layout-main);
    --toast-color-primary-action: var(--toast-color-main);
  }
  &.bold {
    --toast-color-title: var(--color-layout-main);
    --toast-color-body: var(--color-layout-main);
    --toast-color-icon-start: var(--toast-color-title);
    --toast-color-background: var(--toast-color-main);
    --toast-color-primary-action: var(--toast-color-body);

    &.color--warning {
      --toast-color-title: var(--color-neutral-400);
      --toast-color-body: var(--color-neutral-300);
    }
  }
  --toast-color-dismiss-action: var(--toast-color-icon-end);

  background-color: var(--toast-color-background);
`
export const BaseContent = styled.div`
  flex: 1;
`
export const BaseTitle = styled.h5`
  margin: 0;
  margin-top: var(--size-1);
  color: var(--toast-color-title);
`
export const BaseBody = styled.p`
  margin: 0;
  color: var(--toast-color-body);
  margin-top: var(--size-2);
`
export const BaseStartIcon = styled.span`
  margin-top: var(--size-0_5);
  margin-right: var(--size-4);
  color: var(--toast-color-icon-start);
  height: var(--size-6);

  > svg {
    height: var(--size-6);
    width: var(--size-6);
    fill: currentColor;
  }
`

export const BaseEndIcon = styled.span`
  cursor: pointer;
  margin-left: var(--size-4);
  color: var(--toast-color-icon-end, var(--toast-color-body));

  > svg {
    height: var(--size-3);
    width: var(--size-3);
    fill: currentColor;
  }
`

export const BaseToastPrimaryAction = styled.span`
  color: var(--toast-color-primary-action);
  cursor: pointer;
`
export const BaseToastDismissAction = styled.span`
  color: var(--toast-color-dismiss-action);
  cursor: pointer;
`

export const BaseToastFooter = styled.div`
  margin: 0;
  color: var(--toast-color-body);
  margin-top: var(--size-2);

  > * {
    margin-right: var(--size-2);
  }
`
